<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  dialogTitle="Share Article"
  [form]="form"
  submitLabel="Share"
  [submitDisabled]="!form.dirty || !shareTeamsControl.value || shareTeamsControl.value.length === 0"
  [guardUnsavedWork]="form.dirty"
  (submit)="handleShareIsComplete(true)"
  (cancel)="handleShareIsComplete(false)"
>
@if (!!data && data.article !== undefined && data.article !== null) {
<div crucibleDialogContent>
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Share with ...</mat-label>
    <mat-select [formControl]="shareTeamsControl" multiple style="width: 100%;">
      @for (team of data.teamList; track team.id) {
      <mat-option [value]="team.id">
        {{team.name}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (data.isEmailActive) {
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Email Subject</mat-label>
    <input matInput [formControl]="subjectFormControl" />
  </mat-form-field>
  }
  @if (data.isEmailActive) {
  <div class="add-margin left">
    <div>
      <h4>Email Message</h4>
      <angular-editor [placeholder]="'Description'" [formControl]="messageFormControl"
        [config]="editorConfig"></angular-editor>
      @if (messageFormControl.hasError('required')) {
      <mat-error>
        Message is <strong>required</strong>
      </mat-error>
      }
    </div>
  </div>
  }
</div>
}
</crucible-dialog>
